import Icon from "@ant-design/icons";
import React from "react";
import { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";
import {
    AnnotationIcon, TranscriptionIcon, MobileIcon, NeaIcon, SegmentationIcon, CollectionIcon, ExternalIcon,
} from "../../assets/Icons";
import { IconJobType } from "../../enums/enums";

interface Props {
    type: string
}

const EditorIcon: React.FC<Props> = ({type}: Props): React.ReactElement => {
    /**
     * Returns icon for given editor type
     * @return {React.ComponentType<CustomIconComponentProps | React.SVGProps<SVGSVGElement>>} icon
     */
    const getIcon = (): React.ComponentType<CustomIconComponentProps | React.SVGProps<SVGSVGElement>> => {
        const {
            ANNOTATION, TRANSCRIPTION, MOBILE, SEGMENTATION, COLLECTION, EXTERNAL, NEA,
        }: typeof IconJobType = IconJobType;
        let icon: React.FC = AnnotationIcon;

        switch (type) {
            case ANNOTATION:
                icon = AnnotationIcon;
                break;
            case TRANSCRIPTION:
                icon = TranscriptionIcon;
                break;
            case MOBILE:
                icon = MobileIcon;
                break;
            case NEA:
                icon = NeaIcon;
                break;
            case SEGMENTATION:
                icon = SegmentationIcon;
                break;
            case COLLECTION:
                icon = CollectionIcon;
                break;
            case EXTERNAL:
                icon = ExternalIcon;
                break;
            default:
                break;
        }

        return icon;
    };

    return (
        <Icon component={getIcon()} aria-label={type}/>
    );
};

export default EditorIcon;
